module.exports = __webpack_public_path__ + "static/media/logo.18c2b278.png";